import { gql } from "graphql-tag";
import { useMutation } from "@bb-vendure/admin-ui/react";

const CHANGE_CUSTOMS_CLEARANCE_STATE = gql`
  mutation ChangeCustomsClearance($id: ID!, $nextState: String!) {
    changeCustomsClearanceState(id: $id, nextState: $nextState) {
      files {
        source
        preview
        name
      }
      id
      state
      order {
        id
      }
    }
  }
`;

export default function useChangeCustomsClearacneState<T>() {
  return useMutation<T>(CHANGE_CUSTOMS_CLEARANCE_STATE);
}
